import { render, staticRenderFns } from "./InviteMembers.vue?vue&type=template&id=cb40f2c2&scoped=true"
import script from "./InviteMembers.vue?vue&type=script&lang=js"
export * from "./InviteMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb40f2c2",
  null
  
)

export default component.exports